/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { PriceState } from './types';
import { RootState } from '../types';
import { getDefaultState } from '@a/store/utils';

export const state: PriceState = {
  productPrice: { ...getDefaultState() },
};

const namespaced = true;

export const price: Module<PriceState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
